import { useState } from 'react';
import Icon from 'components/Icon';
import Seo from 'components/Seo';

const FAQS = [
  { q: 'Is Devlayar really free?',
    a: 'Yes. All tools on Devlayar are completely free to use. There are no hidden charges, no signup, and no watermarks on your files.' },
  { q: 'Do I need to create an account?',
    a: 'No account is needed. Just open any tool and start using it right away.' },
  { q: 'Are my files safe?',
    a: 'Most of our tools run entirely in your browser, which means your files never leave your device and are never uploaded to a server. For tools that need processing, files are used only for that task and are not stored.' },
  { q: 'Is there a file size limit?',
    a: 'Each tool shows its own limit (for example, 20MB for images or 30MB for PDFs). These limits keep the tools fast and reliable for everyone.' },
  { q: 'Which file formats are supported?',
    a: 'It depends on the tool. PDF tools work with PDF files, image tools support common formats like JPG and PNG, and each tool clearly states what it accepts.' },
  { q: 'Can I use Devlayar on my phone?',
    a: 'Yes. Devlayar works on phones, tablets, and computers. The layout adjusts to your screen size.' },
  { q: 'Do the tools work offline?',
    a: 'The browser-based tools need to load the page once. Tools that download a small helper library (like the PDF download in the resume builder) need an internet connection.' },
  { q: 'How do I report a problem or request a new tool?',
    a: 'We would love your feedback. Visit our Contact page and email us — we read every message.' },
];

export default function FaqPage() {
  const [open, setOpen] = useState(0);

  return (
    <>
    <Seo title="FAQ — Frequently Asked Questions" description="Answers to common questions about Devlayar free online tools." path="/faq" />
    <div className="static-page">
      <div className="container">
        <div className="static-hero">
          <div className="static-hero-icon"><Icon name="info" size={26} /></div>
          <h1>Frequently Asked Questions</h1>
          <p>Quick answers to the most common questions about Devlayar.</p>
        </div>

        <div className="static-body" style={{ maxWidth: 760 }}>
          <div className="faq-list">
            {FAQS.map((item, i) => (
              <div key={i} className={`faq-item ${open === i ? 'open' : ''}`}>
                <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                  <span>{item.q}</span>
                  <Icon name={open === i ? 'arrowRight' : 'arrowRight'} size={16} />
                </button>
                {open === i && <div className="faq-a">{item.a}</div>}
              </div>
            ))}
          </div>

          <div className="alert alert-info" style={{ marginTop: 28 }}>
            <Icon name="info" size={16} />
            <span>Didn't find your answer? <a href="/contact">Contact us</a> and we'll be glad to help.</span>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
